<template>
    <v-card
            max-width="600"
            width="600"
            class="mx-auto"
    >
        <v-card-title class="primary">
            <v-icon
                    large
                    left
                    color="white"
            >
                check
            </v-icon>
            <span class="title white--text">Erfolgreich bestellt!</span>
        </v-card-title>
        <v-card-text>
            <p>In Kürze erhalten Sie eine Bestellbestätigung mit Ihrer Rechnung als PDF an {{email}}.</p>
            <p>Weiterhin erhalten Sie eine Kursplatzbestätigung mit weiteren Details zur Veranstaltung.</p>
            <p>Falls Sie möchten, können Sie Ihre Rechnung auch jetzt herunterladen. Alternativ können Sie das Fenster jetzt schließen.</p>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="secondary" :href="'/checkout/download/'+downloadToken">
                Rechnung <v-icon right small>save_alt</v-icon></v-btn>
            <v-btn color="secondary" outline href="https://www.marburger-bund.de/seminare">
                Weitere Seminare</v-btn>


        </v-card-actions>
    </v-card>
</template>

<script>
    export default {
        name: "SuccessCard",
        props: {
            downloadToken: String,
            email: String,
            pending: Boolean,
        },
        computed: {},
    }
</script>

<style scoped>

</style>
